export const REACT_APP_SSO_API = process.env.REACT_APP_SSO_API;
export const REACT_APP_LOCATION_API = process.env.REACT_APP_LOCATION_API;
export const REACT_APP_SITE_KEY_GOOGLE = process.env.REACT_APP_SITE_KEY_GOOGLE;
export const REACT_APP_DEFAULT_RETURN_URL = process.env.REACT_APP_DEFAULT_RETURN_URL;